"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENTS_REFERENCE_MAX_LENGTH = exports.Environment = exports.CustomerGender = exports.AuthMethod = exports.FieldOfActivity = exports.Language = exports.BigbankHttpHeader = exports.OrganizationCode = exports.DigitalChannelsServiceName = exports.PrecalculatedOperation = exports.AllowedUploadedFileMimeTypes = exports.CountryChannel = void 0;
var CountryChannel;
(function (CountryChannel) {
    CountryChannel["BG"] = "BG";
    CountryChannel["SE"] = "SE";
    CountryChannel["LV"] = "LV";
    CountryChannel["LT"] = "LT";
    CountryChannel["FI"] = "FI";
    CountryChannel["AT"] = "AT";
    CountryChannel["DE"] = "DE";
    CountryChannel["NL"] = "NL";
    CountryChannel["EE"] = "EE";
})(CountryChannel || (exports.CountryChannel = CountryChannel = {}));
exports.AllowedUploadedFileMimeTypes = [
    'image/gif',
    'video/mp4',
    'text/html',
    'video/webm',
    'message/rfc822',
    'application/CDFV2',
    'application/octet-stream', // ???
    'application/vnd.oasis.opendocument.text',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/pdf',
    'application/msword',
    'application/vnd.etsi.asic-e+zip',
    'application/zip',
    'image/jpg',
    'image/png',
    'image/jpeg',
    'text/plain',
    'text/xml',
    'text/rtf'
    // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // https://backlog.big.local/browse/DCP-6438
];
var PrecalculatedOperation;
(function (PrecalculatedOperation) {
    PrecalculatedOperation["LoanContracts"] = "precalc:component-contract:{customerId}:loan-contracts";
})(PrecalculatedOperation || (exports.PrecalculatedOperation = PrecalculatedOperation = {}));
var DigitalChannelsServiceName;
(function (DigitalChannelsServiceName) {
    DigitalChannelsServiceName["SelfService"] = "self_service_chrome";
    DigitalChannelsServiceName["CampaignService"] = "campaign_service";
    DigitalChannelsServiceName["ComponentDeposit"] = "self_service_component_deposit";
    DigitalChannelsServiceName["ComponentDepositWorker"] = "self_service_component_deposit_worker";
    DigitalChannelsServiceName["ComponentAccount"] = "self_service_component_account";
    DigitalChannelsServiceName["ComponentAuthentication"] = "self_service_component_authentication";
    DigitalChannelsServiceName["ComponentContract"] = "self_service_component_contract";
    DigitalChannelsServiceName["CustomerIdService"] = "customer-id-service";
    DigitalChannelsServiceName["FileService"] = "file_service";
    DigitalChannelsServiceName["LoginService"] = "login_service";
    DigitalChannelsServiceName["WelcomeServiceFrontend"] = "welcome_service_frontend";
    DigitalChannelsServiceName["WelcomeServiceBackend"] = "welcome_service_backend";
})(DigitalChannelsServiceName || (exports.DigitalChannelsServiceName = DigitalChannelsServiceName = {}));
var OrganizationCode;
(function (OrganizationCode) {
    OrganizationCode["PP"] = "PP";
    OrganizationCode["RM"] = "RM";
    OrganizationCode["RP"] = "RP";
    OrganizationCode["PMP"] = "PMP";
    OrganizationCode["BANK"] = "BANK";
    OrganizationCode["GROUP"] = "GROUP";
    OrganizationCode["EEBIG"] = "EEBIG";
    OrganizationCode["LVBIG"] = "LVBIG";
    OrganizationCode["FIBIG"] = "FIBIG";
    OrganizationCode["LTBIG"] = "LTBIG";
    OrganizationCode["SEBIG"] = "SEBIG";
    OrganizationCode["BGBIG"] = "BGBIG";
})(OrganizationCode || (exports.OrganizationCode = OrganizationCode = {}));
var BigbankHttpHeader;
(function (BigbankHttpHeader) {
    BigbankHttpHeader["EventName"] = "X-Event-Name";
    BigbankHttpHeader["ClientId"] = "X-BB-Client-ID";
    BigbankHttpHeader["Language"] = "X-BB-Language";
    BigbankHttpHeader["CorrelationId"] = "X-Correlation-ID";
    BigbankHttpHeader["SessionId"] = "X-Session-ID";
    BigbankHttpHeader["Organization"] = "X-BB-Organization";
    BigbankHttpHeader["Channel"] = "X-BB-Channel";
    BigbankHttpHeader["XForwardedFor"] = "X-Forwarded-For";
})(BigbankHttpHeader || (exports.BigbankHttpHeader = BigbankHttpHeader = {}));
var Language;
(function (Language) {
    Language["et"] = "et";
    Language["en"] = "en";
    Language["ru"] = "ru";
    Language["de"] = "de";
    Language["nl"] = "nl";
    Language["fi"] = "fi";
    Language["sv"] = "sv";
    Language["lt"] = "lt";
    Language["lv"] = "lv";
    Language["bg"] = "bg";
})(Language || (exports.Language = Language = {}));
var FieldOfActivity;
(function (FieldOfActivity) {
    FieldOfActivity["PRIVATE_SECTOR"] = "PRIVATE_SECTOR";
    FieldOfActivity["PUBLIC_SECTOR"] = "PUBLIC_SECTOR";
    FieldOfActivity["ENTREPRENEUR"] = "ENTREPRENEUR";
    FieldOfActivity["INDIVIDUAL_ACTIVITY"] = "INDIVIDUAL_ACTIVITY";
    FieldOfActivity["UNEMPLOYED"] = "UNEMPLOYED";
    FieldOfActivity["PENSIONER"] = "PENSIONER";
    FieldOfActivity["STUDENT"] = "STUDENT";
    FieldOfActivity["PARENTAL_LEAVE"] = "PARENTAL_LEAVE";
    FieldOfActivity["CONSCRIPT"] = "CONSCRIPT";
    FieldOfActivity["OTHER"] = "OTHER";
})(FieldOfActivity || (exports.FieldOfActivity = FieldOfActivity = {}));
var AuthMethod;
(function (AuthMethod) {
    AuthMethod["SMART_ID"] = "smartid";
    AuthMethod["MOBILE_ID"] = "mobileid";
    AuthMethod["ID_CARD"] = "idcard";
    AuthMethod["CUSTOMER_ID"] = "customerid";
    AuthMethod["CUSTOMER_DEVICE"] = "customerdevice";
    AuthMethod["BANK_ID"] = "bankid";
    AuthMethod["SIGNICAT"] = "signicat";
    AuthMethod["EVROTRUST"] = "evrotrust";
    AuthMethod["EPARAKSTS"] = "eparaksts";
})(AuthMethod || (exports.AuthMethod = AuthMethod = {}));
var CustomerGender;
(function (CustomerGender) {
    CustomerGender[CustomerGender["Male"] = 0] = "Male";
    CustomerGender[CustomerGender["Female"] = 1] = "Female";
})(CustomerGender || (exports.CustomerGender = CustomerGender = {}));
var Environment;
(function (Environment) {
    Environment["Production"] = "production";
    Environment["Staging"] = "staging";
    Environment["Test"] = "test";
    Environment["Development"] = "development";
    Environment["Qa"] = "qa";
    Environment["Uat"] = "uat";
})(Environment || (exports.Environment = Environment = {}));
exports.PAYMENTS_REFERENCE_MAX_LENGTH = 20;
